export const GoogleMapApiConfig = 'AIzaSyD5d3jsK70-RqNcKo2Z8GViY9xnK0PWNRQ';